import { GENERIC_EXPORT_RECEIVE, GENERIC_EXPORT_STORE_TYPE, GENERIC_EXPORT_STORE_TYPE_INDEX, GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS } from '../Actions/GenericExport.action';

const defaultState = {
    exportObjects: [],
   // exportFieldItems: [],
    exportDone: false,
    fieldTemplate: '',
    activeType: '',
    areaTypeName: '',
    activeObjectIndex: -1,
    exportJobObject: [{
        exportResponseType: '',
        exportTypeName: '',
        method: '',
        fieldItems: [],
    }],
}

export const genericExport = (state = defaultState, action) => {
    switch (action.type) {
        case GENERIC_EXPORT_RECEIVE:
        case GENERIC_EXPORT_STORE_TYPE:
        case GENERIC_EXPORT_STORE_TYPE_INDEX: 
        case GENERIC_EXPORT_STORE_UPDATE_EXPORT_OBJECTS:
           
        return {
            ...state,
            ...action.payload,
        };
        default:
        return state;
    }
}